import ajax from '@/helpers/ajax'
import { trackShareOpen } from '@/analytics/track'
import { v4 as uuid } from 'uuid'

export default {
  methods: {
    trackEvent(shareClickToken) {
      const entityType = this.sharingOptions.entityType
      const entitySlug = this.sharingOptions.entitySlug
      const shareClicksPath = this.sharingOptions.shareClicksPath

      // Tell other Javascript on the page
      document.dispatchEvent(new Event('agra:share-button-clicked'))

      // Track analytics
      trackShareOpen(this.channelNameForAnalytics, entityType, entitySlug)

      // If applicable, return shareClickToken, and create ShareClick asynchronously
      if (shareClicksPath) {
        if (!shareClickToken) {
          shareClickToken = uuid()
        }
        ajax.post({
          url: shareClicksPath,
          data: {
            token: shareClickToken
          }
        })
        return shareClickToken
      }
      return null
    },

    urlWithShareClickTokenInInnerUrl(url, shareClickToken, innerUrlParamName) {
      if (shareClickToken === null) {
        return url
      }

      const urlObj = new URL(url)

      // add the share_click_id param to inner url param
      const searchParams = new URLSearchParams(urlObj.search.slice(1))
      let innerUrl = searchParams.get(innerUrlParamName)

      innerUrl += `&share=${shareClickToken}`

      urlObj.searchParams.set(innerUrlParamName, innerUrl)
      return urlObj.href
    }
  }
}
